var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTable',{attrs:{"headers":_vm.headers,"items":_vm.itemsSorted,"editable":false,"deleteable":false,"pagination":false},on:{"sort":_vm.sortItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }